// src/utils/useIDBState.js
import { useEffect, useRef, useState } from 'react';
import { getJSON, setJSON } from './idbKV';

export default function useIDBState(key, initialValue) {
    const [state, setState] = useState(initialValue);
    const readyRef = useRef(false);

    // load once
    useEffect(() => {
        let alive = true;
        (async () => {
            const val = await getJSON(key, initialValue);
            if (alive) {
                setState(val);
                readyRef.current = true;
            }
        })();
        return () => { alive = false; };
    }, [key]);

    // persist on change (after initial load)
    useEffect(() => {
        if (!readyRef.current) return;
        const t = setTimeout(() => { setJSON(key, state).catch(() => { }); }, 100);
        return () => clearTimeout(t);
    }, [key, state]);

    return [state, setState];
}
